__webpack_require__.p = "/energy/water/paper/uttana_kannada/";